import styled from 'styled-components'
import { Paper } from '@material-ui/core'
import { StyledH4, GraphHeading, theme } from '../../../theme/Global'

export const Title = styled(GraphHeading)`
  padding-top: 2.5rem;
  padding-bottom: 2rem;
`

export const DateSpan = styled(StyledH4)`
  width: 100%;
  display: block;
  padding: 0;
  margin-bottom: 2.2rem;
  color: ${theme.colors.redText};
`

export const RenewalDue = styled(StyledH4)`
  width: 100%;
  padding: 0;
  font-size: 16px;
`

export const WidgetContainer = styled(Paper)`
  height: 235px;
  box-shadow: unset;
`
